import { Routes, Route } from "react-router-dom";
import Dashboard from "../page/Dashboard";
import AddEditTicket from "../page/AddEditTicket";
import Tickets from "../page/Tickets";
import Error from "../page/Error";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/tickets" element={<Tickets />} />
      <Route path="/add-ticket" element={<AddEditTicket />} />
      <Route path="/edit-ticket/:id" element={<AddEditTicket />} />
      <Route path="*" element={<Error />} />
    </Routes>
  );
}

